<template>
  <div class="home-container">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="refreshDisabled">
<!--      <img class="ywsm_pic" @click="clickYewuDesc" src="../../assets/huiy/yw_icon.png" alt="">-->
      <div class="lqjl_div" @click="lingquRecored">
        <img class="lqjl_pic" src="../../assets/huiy/lqjl_icon.png" />
      </div>
      <div class="top-content">
          <div class="sculpture">
            <img class="pic" src="../../assets/huiy/member.png" alt="">
          </div>
          <div class="phone">尊敬的{{mobile}}用户您好</div>

        <div class="warefale" >
          <img v-if="!hasReceiveMode" class="pic" style="width: 100%;border-radius: 0.4rem;border: 2px solid white;" src="../../assets/index/shop_banner.png" alt="">
          <img v-if="hasReceiveMode" class="pic" style="width: 100%;border-radius: 0.4rem;border: 2px solid white;" src="../../assets/index/selectMode.jpg" alt="" @click="openModal">
        </div>
      </div>


      <!-- 专区数据 -->
      <div class="zone-section" v-if="isShd && hasCoupon">
        <!-- <div class="active-flag">
          <img class="sjx-icon" src="../../assets/huiy/sjx.png" alt="">
        </div> -->
        <div class="regin-section">
          <div class="title">
            <div class="regin-desc">
              <span>微信代金券专区</span>
            </div>
          </div>
          <div class="index-list" style="margin-bottom: 1rem;">
<!--            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onloads"  :immediate-check="false" style="height:280px;overflow-y: auto;">-->
              <div class="list-content" @click="selecthref('scdetail', { detailid: i.id })" v-for="i in goodslist"
                   :key="i.id">
                <div class="list-img">
                  <img :src="i.logo">
                </div>
                <div class="list-info">
                  <span>{{ i.storeName }}</span>
                  <span>满{{ i.couponType }}.10元可用</span>
                  <span>
                {{ i.address }}
              </span>
                </div>
              </div>
<!--            </van-list>-->
          </div>
          <div @click="selecthref('goodslist', { couponType: 10, couponTitle: couponTitle })" class="index-bottom"
               style="margin-bottom:0.35rem">
<!--            <van-loading v-show="loading == '1'" size="24px">加载中...</van-loading>-->
<!--            <span v-show="loading == '0'">查看更多</span>-->
<!--            <span v-show="loading == '3'" style="color: #6A737D;">已无更多</span>-->
            <span>查看更多</span>
          </div>
        </div>
      </div>
      <div class="zone-section" v-if="isShd && isQd && hasWxCouopon">
        <div class="regin-section">
          <div class="title">
            <div class="regin-desc">
<!--              <img class="zq-icon" src="../../assets/huiy/wxnicon.png" alt="">-->
              <span>10元代金券专区</span>
            </div>
          </div>
          <div class="regin-list">
            <div class="regin-item" :class="it.isEnable ==2?'enabled-item':''" v-for="(it,ind) in wxFoodList" :key="ind" @click="selecthref('cxDetail', {id:it.id, couponBatchId: it.couponBatch,couponGroup:it.couponGroup })">
              <span class="hyTag">会员专区</span>
              <img class="regin-pic" :src="it.couponLogo" alt="">
              <div class="regin-info">
                <div class="name">{{ it.couponName }}</div>
                <div class="desc">{{ it.couponSubtitle }}</div>
              </div>
              <div class="lingqu-btn">立即领取</div>
            </div>
          </div>
        </div>
      </div>

      <div class="zone-section" v-if="wx15FoodList.length>0">
        <div class="regin-section">
          <div class="title">
            <div class="regin-desc">
<!--              <img class="zq-icon" src="../../assets/huiy/wxnicon.png" alt="">-->
              <span>5元代金券专区</span>
            </div>
          </div>
          <div class="regin-list">
            <div class="regin-item" :class="it.isEnable ==2?'enabled-item':''" v-for="(it,ind) in wx15FoodList" :key="ind" @click="selecthref('cxDetail', {id:it.id, couponBatchId: it.couponBatch,couponGroup:it.couponGroup })">
              <span class="hyTag">会员专区</span>
              <img class="regin-pic" :src="it.couponLogo" alt="">
              <div class="regin-info">
                <div class="name">{{ it.couponName }}</div>
                <div class="desc">{{ it.couponSubtitle }}</div>
              </div>
              <div class="lingqu-btn">立即领取</div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="zone-section">-->
<!--        <div class="regin-section">-->
<!--          <div class="title">-->
<!--            <div class="regin-desc">-->
<!--              <img class="zq-icon" src="../../assets/huiy/ylnicon.png" alt="">-->
<!--              <span>银联代金券专区</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="regin-list">-->
<!--            <div class="regin-item" :class="it.isEnable ==2?'enabled-item':''" v-for="(it,ind) in ylFoodList" :key="ind" @click="selecthref('msDetail', { couponBatchId: it.couponBatch })">-->
<!--              <span class="hyTag">会员专区</span>-->
<!--              <img class="regin-pic" :src="it.couponLogo" alt="">-->
<!--              <div class="regin-info">-->
<!--                <div class="name">{{ it.couponName }}</div>-->
<!--                <div class="desc">{{ it.couponSubtitle }}</div>-->
<!--              </div>-->
<!--              <div class="lingqu-btn">立即领取</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </van-pull-refresh>


    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close-btn" @click="showModal = false">&times;</span>
        <h5>请设置您的卡券领取规则</h5>
        <div
          v-for="(option, index) in options"
          :key="index"
          :class="['option', { selected: selectedOption === index }]"
          @click="selectOption(index)"
        >
          <span class="icon">¥</span>
          <span>{{ option.text }}</span>
        </div>
        <p style="font-size:0.4rem">注：设置后不可修改，请谨慎操作。如不设置默认为单月领取4张5元代金券。</p>
        <button @click="submitSelection">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index.js";
import {
  getIndexCouponList,
  getCouponList,
  getuserInfo,
  getReceiveMode,
} from "@/api/user";
import { mapState } from "vuex";
import { getItem, setItem } from "@/utils/storage";
import {
  Toast,
  Dialog
} from 'vant';
export default {
  name: "home",
  components: {

  },
  props: {},
  data() {
    return {
      refreshDisabled: false, // 下拉组件刷新是否禁用
      tabActive: 'df',
      size: "100",
      notice_text: "",
      isLoading: false,
      BMap: null,
      geolocation: null, // Geolocation对象实例
      positioning: false, // 定位中
      countDown: 30, // 倒计时，单位秒
      location: null, // 位置信息
      active: 0, //被激活的列表
      city: "",
      goodslist: [], //商品列表
      wxFoodList: [], // 微信美食代金券
      wx15FoodList: [], // 微信美食代金券
      ylFoodList: [], // 银联美食代金券
      longitude: "", //经度
      latitude: "", //纬度
      areaId: "", //城市id,
      ltAreaCode: "",
      from: 0,
      couponTitle: "",
      mobile: "",
      show: false,
      articlec: "",
      articlec_content: "",
      couponType: "",
      loading: false,
      loadings: "0",
      datas: {
        city: "",
      },
      userType: "",
      value: "",
      isloop: 1,
      source:'',
      couponGroup:2,
      isShd:true,
      isQd:false,
      hasCoupon:true,
      finished: false,
      ltCityCode:'',
      showModal: false,
      options: [
        { text: '单月领取4张5元代金券' },
        { text: '单月领取2张10元代金券' }
      ],
      selectedOption: 0, // 默认选择第一个选项
      hasReceiveMode:false,
      couponAmount:10,
      hasWxCouopon:true
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    $route() {
      location.reload();
      this.$dialog.close();
      this.show = false;
    },

  },
  async created() {},
  async mounted() {

    this.source=sessionStorage.getItem("source")

    console.log(this.source);
    this.isShd=false;
    if(sessionStorage.getItem("source")=='yn'){
      this.couponType=1
    }else if(sessionStorage.getItem("source")==='nx'){
      this.couponType=2
    }else if(sessionStorage.getItem("source")==='sd'){
      this.isShd=true;
      this.couponType=3
    }else if(sessionStorage.getItem("source")==='nmg'){
      this.couponType=4
    }else if(sessionStorage.getItem("source")==='js'){
      this.couponType=5
    }else{
      this.isShd=true;
    }

    if (sessionStorage.getItem("ticket") != "1") {
      //如果ticket在运行期间存在 就不在请求
      var ticket = this.geturl();
      var value = this.getValue();
      if (ticket != "" || value != "") {
        var mobile = await this.geticket(ticket, value);
        //await this.get_token(mobile)
        sessionStorage.setItem("ticket", "1");
      }
    }
    setItem("show", false);

    if(this.isShd){
      this.handleLocationFallback()
    }else{
      this.onload()
    }
    this.mobile = getItem("mobile");



  },

  methods: {

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    selectOption(index) {
      this.selectedOption = index;
    },
    async submitSelection() {
      console.log('Selected option:', this.selectedOption);

      let params={
        "receiveMode":this.selectedOption
      }
      const{
        data
      } = await getReceiveMode(params)
      console.log(data)
      if(data.data===true){
        this.closeModal();
        this.hasReceiveMode=false
        // this.couponAmount=this.selectedOption===0?5:10
        // this.onload()
      }
    },
    // 领取记录跳转
    lingquRecored(){
      var param;
      var name='ljjl1'
      let userArea = getItem('userArea')
      if (userArea.id == 15) {
          name='ljjl'
      }
      if(this.source!=='sd'){
         param=  {type: 2}
      }
      this.$router.push({
        name: name,
        params: param
      });
    },
    geturl() {
      try {
        var url = window.location.href; //获取当前url
        // var dz_url = url.split('#')[1]; //获取#/之后的字符串
        var dz_url = url.split("#")[0]; //获取#/之前的字符串
        var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
        var cs_arr = cs.split("&"); //参数字符串分割为数组
        var cs = {};
        for (var i = 0; i < cs_arr.length; i++) {
          //遍历数组，拿到json对象
          cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
        }
        return decodeURIComponent(cs.ticket);
      } catch (e) {
        return "";
      }
    },
    getValue() {
      try {
        var url = window.location.href; //获取当前url
        var dz_url = url.split("#")[0]; //获取#/之前的字符串
        var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
        var reg = new RegExp("(^|&)" + "value" + "=([^&]*)(&|$)", "i");
        var r = cs.match(reg);
        if (r != null) {
          return unescape(r[2]); //unescape()将url编码字符串转换为正常编码。
        }
        return null;
      } catch (e) {
        return "";
      }
    },

    // 手机号码隐藏中间四位数处理
    mobileManage(str) {
      return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },


    async geticket(userInfo, value) {
      let parma = {
        ticket: userInfo,
        value: value,
      };
      const { data } = await getTokenForTicket(parma);
      var dats = {
        token: data.data,
      };
      this.$store.dispatch("AddUser", dats);
      return data.data;
    },

    async userinfo() {
      const { data } = await getuserInfo();
      if (data.data && data.data.userType){
        if (data.data.userType){
          this.userType = data.data.userType
        }
        if (data.data.mobile){
          // 手机号处理****
          this.mobile = this.mobileManage(data.data.mobile);
        }
        this.ltCityCode=data.data.ltCityCode
        //this.hasReceiveMode=data.data.receiveMode===null && data.data.ltCityCode==='151'
        this.isQd=data.data.ltCityCode=='166'

              // 检查 ltCityCode 并跳转
        // if (data.data.ltCityCode === '151') {
        //   this.openModal();
        // }
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      this.from = 0;
      this.wxFoodList = []; // 微信美食代金券
      this.wx15FoodList = []; // 微信美食代金券
      this.ylFoodList = [];// 银联美食代金券
      this.goodslist=[]
      this.onload();
    },
    async onload() {
      this.from = 0;
      this.wxFoodList = []; // 微信美食代金券
      this.wx15FoodList = []; // 微信美食代金券
      this.ylFoodList = [];// 银联美食代金券
      this.goodslist=[]
      await this.userinfo();
      await  this.CouponList();
      await this.CouponIndexList();
    },
    selecthref(href, data = "") {
      if (data != "") {
        setItem("show", true);
      }
      console.log("详情页面", data);
      this.$router.push({
        name: href,
        params: data,
      });
    },

    getlocation() {
      const _this = this
      
      // 检查移动端环境和HTTPS要求
      if (_this.isMobile() && !_this.isSecureContext()) {
        console.warn('移动端需要HTTPS环境才能使用定位功能');
        Toast.clear()
        Toast.fail('定位失败')
        _this.handleLocationFallback()
        return
      }
      
      // 检查是否支持定位
      if (!_this.BMap || !_this.BMap.Geolocation) {
        console.error('百度地图API未正确加载');
        // 在移动端尝试使用原生定位作为备用
        if (_this.isMobile() && navigator.geolocation) {
          console.log('尝试使用移动端原生定位');
          _this.tryMobileNativeLocation()
          return
        }
        Toast.clear()
        Toast.fail('定位失败')
        _this.handleLocationFallback()
        return
      }

      let baidu = new _this.BMap.Geolocation()
      
      baidu.getCurrentPosition((r) => {
        console.log(r, '获取定位信息');
        
        _this.latitude = r.latitude
        _this.longitude = r.longitude
        setItem('latitude', _this.latitude)
        setItem('longitude', _this.longitude)
        
        // 检查地址信息是否存在
        if (r.address && r.address.city) {
          setItem('addressCity', r.address.city)
          _this.city = r.address.city;
        }
        
        if (getItem('localtion') && getItem('localtion').name !== null) {
          if (getItem('localtion') && getItem('localtion').name) {
            _this.city = getItem('localtion').name
          }
          if (getItem('localtion') && getItem('localtion').id) {
            _this.areaId = getItem('localtion').id
          }
          if (getItem('localtion') && getItem('localtion').ltAreaCode) {
            _this.ltAreaCode = getItem('localtion').ltAreaCode
          }
        } else if (r.address && r.address.city) {
          _this.city = r.address.city
        }
        
        _this.onload()
        Toast.clear()
      }, (error) => {
        console.error('百度地图定位失败:', error);
        _this.handleBaiduLocationError(error)
      }, {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 60000
      })
    },

    // 检测是否为移动端
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },

    // 检测是否为安全上下文
    isSecureContext() {
      return window.isSecureContext || location.protocol === 'https:' || location.hostname === 'localhost'
    },

    // 处理百度地图定位错误
    handleBaiduLocationError(error) {
      const _this = this
      console.error('百度地图定位错误详情:', error);
      
      let errorMessage = '定位失败'
      let shouldTryNative = false
      
      // 分析具体错误类型
      if (error && typeof error === 'object') {
        // 检查是否为空对象（常见的百度地图API错误）
        if (Object.keys(error).length === 0) {
          console.warn('百度地图返回空错误对象，可能原因：');
          console.warn('1. AK配额限制或权限不足');
          console.warn('2. 定位服务暂时不可用');
          console.warn('3. 网络连接问题');
          console.warn('4. 浏览器兼容性问题');
          errorMessage = '定位服务暂时不可用，正在尝试其他方式...'
          shouldTryNative = true
        } else if (error.message) {
          console.log('错误消息:', error.message);
          
          if (error.message.includes('服务不可用') || error.message.includes('service unavailable')) {
            errorMessage = '定位服务暂时不可用，正在尝试其他方式...'
            shouldTryNative = true
          } else if (error.message.includes('权限') || error.message.includes('permission')) {
            errorMessage = '定位权限被拒绝，请允许访问位置信息'
          } else if (error.message.includes('超时') || error.message.includes('timeout')) {
            errorMessage = '定位请求超时，正在重试...'
            shouldTryNative = true
          } else if (error.message.includes('网络') || error.message.includes('network')) {
            errorMessage = '网络连接异常，正在尝试其他方式...'
            shouldTryNative = true
          }
        }
        
        // 检查错误代码
        if (error.code !== undefined) {
          console.log('错误代码:', error.code);
          switch (error.code) {
            case 2:
              errorMessage = '定位服务不可用'
              shouldTryNative = true
              break
            case 3:
              errorMessage = '定位请求超时'
              shouldTryNative = true
              break
            case 6:
              errorMessage = '定位服务异常'
              shouldTryNative = true
              break
          }
        }
      }
      
      Toast.clear()
      
      // 如果是服务问题且在移动端，尝试原生定位
      if (shouldTryNative && _this.isMobile() && navigator.geolocation) {
        console.log('百度地图定位失败，尝试使用移动端原生定位');
        Toast.loading(errorMessage)
        _this.tryMobileNativeLocation()
        return
      }
      
      // 否则显示错误并使用备用方案
      Toast.fail(errorMessage)
      _this.handleLocationFallback()
    },

    // 移动端原生定位
    tryMobileNativeLocation() {
      const _this = this
      
      if (!navigator.geolocation) {
        console.error('浏览器不支持地理位置API');
        Toast.clear()
        Toast.fail('您的浏览器不支持定位功能')
        _this.handleLocationFallback()
        return
      }

      // 移动端友好的定位选项
      const options = {
        enableHighAccuracy: true,
        timeout: 20000, // 移动端网络可能较慢，增加超时时间
        maximumAge: 300000 // 5分钟内的缓存位置可接受
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('移动端原生定位成功:', position);
          
          _this.latitude = position.coords.latitude
          _this.longitude = position.coords.longitude
          setItem('latitude', _this.latitude)
          setItem('longitude', _this.longitude)
          
          // 设置默认城市信息
          const savedCity = getItem('addressCity')
          if (savedCity) {
            _this.city = savedCity
          } else {
            _this.city = '当前位置'
            setItem('addressCity', _this.city)
          }
          
          Toast.clear()
          _this.onload()
        },
        (error) => {
          console.error('移动端原生定位失败:', error);
          Toast.clear()
          
          let errorMessage = '定位失败'
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = '请允许浏览器访问您的位置信息'
              break
            case error.POSITION_UNAVAILABLE:
              errorMessage = '无法获取位置信息'
              break
            case error.TIMEOUT:
              errorMessage = '定位请求超时'
              break
          }
          
          Toast.fail(errorMessage)
          _this.handleLocationFallback()
        },
        options
      )
    },

    handleLocationFallback() {
      const _this = this
      
      // 尝试使用之前保存的位置信息
      const savedLatitude = getItem('latitude')
      const savedLongitude = getItem('longitude')
      const savedCity = getItem('addressCity')
      
      if (savedLatitude && savedLongitude) {
        console.log('使用缓存的位置信息');
        _this.latitude = savedLatitude
        _this.longitude = savedLongitude
        if (savedCity) {
          _this.city = savedCity
        }
      } else {
        // 使用默认位置（可以根据业务需求设置）
        console.log('使用默认位置信息');
        //_this.latitude = '36.6512'  // 滨州市默认坐标
       // _this.longitude = '117.9708'
         _this.latitude = "36.646994";
          _this.longitude = "116.994787";
        _this.city = '济南市'
        setItem('latitude', _this.latitude)
        setItem('longitude', _this.longitude)
        setItem('addressCity', _this.city)
      }
      
      // 检查本地存储的位置信息
      if (getItem('localtion') && getItem('localtion').name !== null) {
        if (getItem('localtion').name) {
          _this.city = getItem('localtion').name
        }
        if (getItem('localtion').id) {
          _this.areaId = getItem('localtion').id
        }
        if (getItem('localtion').ltAreaCode) {
          _this.ltAreaCode = getItem('localtion').ltAreaCode
        }
      }
      
      _this.onload()
    },

    async CouponIndexList() {
      let param = {
        couponGroup: this.couponGroup, //券模块0-缴费宝1-出行
        couponType: [this.couponType]
      };
      const { data } = await getIndexCouponList(param);
      console.log('模块优惠券',data);
      if (Array.isArray(data.data) && data.data.length){
          data.data.forEach( item => {

            item.list.filter(i=>  (i.couponLink==='' || i.couponLink.includes(this.ltCityCode))).forEach( it =>{
              if(it.couponPrice==='10'){
                this.wxFoodList.push({...it,couponGroup:item.couponGroup,couponType:item.couponType});
              } else if(it.couponPrice==='5'){
                this.wx15FoodList.push({...it,couponGroup:item.couponGroup,couponType:item.couponType});
              }
            })
        })
      }else{
        this.hasWxCouopon=false
      }
    },
    async CouponList() {
      let param = {
        latlon: this.latitude + ',' + this.longitude,
        // latlon: this.longitude + ',' + this.latitude,
        couponType: 10,
        // areaId: this.areaId,
        areaId: '',
        from: this.from+=1,
        size: 10,
        //areaName: this.city,
        couponClassify: 0,
      }
      const {data} = await getCouponList(param)
      // this.goodslist = data.data
      if (JSON.stringify(this.goodslist) === '[]') {
        this.goodslist = data.data
      } else {
        data.data.forEach((i, k) => {
          this.goodslist.push(i)
        })
      }
      if (JSON.stringify(data.data) === '[]' ) {
        this.hasCoupon=false;
      }
    },
    onloads(){

      this.CouponList()
    }

  }
};
</script>

<style scoped lang="less">
  .home-container {
    padding-bottom: 1rem;
    width: 100%;
    height: 100%;
    background-color: #FD7A9C;
    overflow: auto;
  }
  .index-bottom {
    /* margin: 0rem 0px; */
    width: 90%;
    background: #f7f8fa;
    margin: 0 auto;
    font-size: 0.4rem;
    /* margin-top: 0.1rem; */
    margin-bottom: 2rem;
    padding: 0.3rem;
    text-align: center;
    border-radius: 0.2rem;

  }
  .list-content {
    border-radius: 0.2rem;
    margin-bottom: 0.3rem;
    display: flex;
    background: url(../../assets/img2/goodslistbg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0.3rem 0.5rem;

    img {
      display: block;
      // width: 1.8rem;
      height: 2rem;
    }
  }
  .list-info {
    padding-left: 0.5rem;

    span {
      display: block;
      font-size: 0.3rem;

      &:nth-child(1) {

        font-size: 0.4rem;
        color: #333333;
        font-family: SourceHanSansCN-Regular;
      }

      &:nth-child(2) {
        padding: 0.1rem 0;
        font-size: 0.3rem;
        background: #FFE9E9;
        border-radius: 0.25rem;
        text-align: center;
        margin: 0.28rem;
        width: 2.5rem;
        color: #E60027;
        margin-left: 0;
      }

      &:nth-child(3) {
        font-size: 0.3rem;
        color: #999999;
      }
    }

  }
  .yewu-content {
    height: 100%;
    .title-yewu {
      width: 100%;
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;
      font-size: 0.45rem;
      font-weight: 600;
    }
    .main-cont {
      padding: 0.3rem;
      height: 80%;
      overflow: hidden;
      overflow-y: scroll;
    }
    .item-cont {
      margin-top: 0.3rem;
      .title {
        font-size: 0.42rem;
        font-weight: 500;
      }
      .title1 {
        margin-top: 0.2rem;
        font-size: 0.4rem;
      }
      .text-desc {
        padding-left: 0.1rem;
        margin-top: 0.2rem;
        font-size: 0.38rem;
        font-weight: 500;
      }
    }
  }
  .ywsm_pic {
    position: absolute;
    top: 1.53rem;
    right: 0;
    z-index: 4;
    width: 0.63rem;
    height: 2.07rem;
  }
  .lqjl_div {
    position: absolute;
    top: 3.99rem;
    z-index: 999;
    right: 0;
    width: 0.64rem;
    height: 2.09rem;
    /**border: 1px dashed #000; **/
  }
  .lqjl_pic {
    top: 3.99rem;
    right: 0;
    width: 0.64rem;
    height: 2.09rem;
  }
  .top-content{
    padding-top: 0.87em;
    position: relative;
    width: 100%;
    // height: 6.4rem;
    background: url('../../assets/huiy/hy_top.png') no-repeat;
    background-size: 100% 100%;
    .sculpture {
      text-align: center;
      .pic {
        width: 1.43rem;
        height: 1.43rem;
        border-radius: 50%;
      }
    }
    .phone {
      margin-top: 0.43rem;
      color: #000;
      font-size: 0.45rem;
      font-weight: 600;
      text-align: center;
    }
    .tabs-lists {
      margin-top: 0.87rem;
      padding: 0 0.2rem 0 0.32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tabItem {
        position: relative;
        padding: 0.63rem 0 0.1rem 0;
        width: 2.6rem;
        text-align: center;
        background: #FFFFFF;
        border: 0.05px solid #FFE399;
        border-radius: 0.13rem;
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333;
        .icon {
          position: absolute;
          left: 25%;
          top: -0.52rem;
          width: 1.23rem;
          height: 1.23rem;
        }
        .name {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .sybol {
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 50%;
          text-align: center;
          line-height: 0.28rem;
          color: #fff;
          background: #F2A51C;
        }
      }
      .tabItem1 {
        width: 1.8rem;
        .icon {
          position: absolute;
          left: 0.33rem;
          top: -0.52rem;
          width: 1.23rem;
          height: 1.23rem;
        }
      }
      .tabActive {
        color: #000000;
      }
    }
  }

  .zone-section {
    padding: 0 0.32rem;
    margin-top: 0.37rem;
    margin-bottom: 0.37rem;
    .active-flag1 {
      display: flex;
      width: 100%;
      height: 0.35rem;
      padding-left: 0.58rem;
    }
    .active-flag2 {
      display: flex;
      width: 100%;
      height: 0.35rem;
      padding-left: 2.48rem;
    }
    .active-flag3 {
      display: flex;
      width: 100%;
      height: 0.35rem;
      padding-left: 4.38rem;
    }
    .sjx-icon {
      width: 0.72rem;
      height: 0.35rem;
    }
  }
  .regin-section {
    padding-bottom: 0.6rem;
    border-radius: 0.4rem;
    background-color: #fff;
    .title {
      padding-left: 0.35rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 1.08rem;
      background: #FFFCF5;
      border-radius: 0.27rem 0.27rem 0 0;
    }
    .regin-desc {
      display: flex;
      align-items: center;
      font-size: 0.45rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      .t-pic {
        margin-right: 0.24rem;
        width: 0.85rem;
        height: 0.81rem;
      }
      .zq-icon {
        margin-right: 0.2rem;
        // width: 0.9rem;
        height: 0.79rem;
      }
    }
    .more {
      font-size: 0.35rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #A18B59;
    }
    .regin-list {
      padding: 0.53rem 0.47rem 0 0.37rem;
      //height: 320px;
      //overflow-y: auto;
      .regin-item {
        position: relative;
        margin-bottom: 0.3rem;
        padding: 0.37rem 0.61rem 0.39rem 0.39rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 0.4rem;
        // width: 9.23rem;
        width: 100%;
        // height: 2.57rem;
        background: url('../../assets/huiy/zq_bg.png') no-repeat;
        background-size: 100% 100%;
        // background: linear-gradient(to right, rgb(242, 215, 169), rgb(245,228,195));
      }
      .hyTag {
        position: absolute;
        top: 0.05rem;
        right: 0.23rem;
        height: 0.32rem;
        font-size: 0.35rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9E601A;
      }
      .regin-pic {
        width: 1.77rem;
        height: 1.77rem;
        border-radius: 50%;
      }
      .regin-info {
        // margin-left: 0.43rem;
        width: 42%;
        .name {
          // font-size: 0.53rem;
          font-size: 0.4rem;
          color: #935517;
          font-family: SourceHanSansCN-Regular;
        }
        .desc {
          margin-top: 0.2rem;
          font-size: 0.4rem;
          font-family: Source Han Sans CN;
          color: #FF5907;
        }
        .manjian {
          font-size: 0.3rem;
          background: #ffe9e9;
          border-radius: 0.3rem;
          text-align: center;
          margin: 0.18rem 0;
          width: 2.5rem;
          color: #FF5907;
        }
        .address {
          font-size: 0.3rem;
          color: #999999;
        }
      }
      .name-wel {
        width: 40%;
        font-size: 0.45rem;
        color: rgb(143, 82, 22);
      }
      .lingqu-btn {
        width: 2.39rem;
        height: 0.8rem;
        line-height: 0.8rem;
        text-align: center;
        font-size: 0.38rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: 0rem 0rem 0rem rgba(0,0,0,0.83);
        background: linear-gradient(90deg, #FFBB6B 0%, #FF731E 100%);
        box-shadow: 0rem 0rem 0rem 0rem rgba(211,89,0,0.39);
        border-radius: 0.4rem;
      }
      .enabled-item {
        background: #EEEEEE;
        box-shadow: 0rem 0rem 0rem 0rem rgba(169,107,38,0.54);
        .desc {
          color: #949494;
        }
        .lingqu-btn {
          background: #D1D1D1;
          color: #FFFFFF;
          box-shadow: 0rem 0rem 0rem 0rem rgba(211,89,0,0.39);
        }
      }
    }
    .view-more{
      margin: 0 auto;
      margin-top: 0.93rem;
      width: 4.04rem;
      height: 0.72rem;
      line-height: 0.72rem;
      text-align: center;
      border: 0.01rem solid #BBAC8E;
      border-radius: 0.36rem;
      font-size: 0.35rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #A18B59;
    }
  }
  .warefale {
    margin-top: 0.76rem;
    padding: 0 0.32rem;
  }

  .van-grid-item__content {
    padding: 0.42667rem 0rem;
  }
  .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    position: relative;
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

    .close-btn {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 24px;
      font-weight: bold;
      cursor: pointer;
      color: #aaa;
      &:hover {
        color: #000;
      }
    }
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  .option {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    background-color: #fff;
    transition: background-color 0.3s, border-color 0.3s;
    font-size:0.45rem
  }

  .option.selected {
    border-color: #f56c6c;
    background-color: #fef0f0;
  }

  .icon {
    margin-right: 10px;
    color: #f56c6c;
  }

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 0.5rem;
    background-color: #f56c6c;
    color: #fff;
    cursor: pointer;
    width: 100%;
    margin-top: 20px;
    transition: background-color 0.3s;
  }

  button:hover {
    background-color: #f44336;
  }
</style>
